import { getErrorMessage, isApiError, isApiResponseError } from '@/utils/errors'
import type { LogError } from '@/utils/logger'

/** Preserve the original failure shape when logging an API or native throw. */
export function readLogError(error: unknown, fallback?: LogError): LogError | undefined {
  if (isApiError(error)) {
    return {
      type: 'ApiError',
      message: getErrorMessage(error),
      failure: error.failure,
      status: isApiResponseError(error) ? error.status : undefined,
      requestId: isApiResponseError(error) ? error.requestId : undefined,
      recoveryAction: fallback?.recoveryAction,
    }
  }
  if (error instanceof Error) {
    return {
      type: error.name,
      message: error.message,
      stackTrace: import.meta.env.DEV ? error.stack : undefined,
      recoveryAction: fallback?.recoveryAction,
    }
  }
  if (error === undefined) return fallback
  return {
    type: fallback?.type ?? 'Unknown',
    message: getErrorMessage(error),
    recoveryAction: fallback?.recoveryAction,
  }
}
